import { mount } from './dom-lifecycle';

/*
	Proste modale z makiety (paragon, „Jak odebrać nagrody?”). Nie używamy modala
	bootstrapowego, bo makieta ma własny panel i krzyżyk, a Bootstrap dokłada swoje
	tło, animacje i klasę `modal-open` na body.

	Kontrakt HTML:
	  otwierający   `<a data-modal-open="jak-odebrac">`
	  modal         `<div data-modal="jak-odebrac" hidden>`
	  zamykający    `<button data-modal-close>` (albo kliknięcie w przyciemnienie / Escape)
*/

const SCROLL_LOCK = 'pp-modal-open';

export function openModal(modal) {
    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add(SCROLL_LOCK);
    /*
		Focus idzie na PANEL, nie na krzyżyk. Programowe `focus()` na przycisku wywołuje
		w Chrome `:focus-visible`, więc modal otwierał się z obwódką na krzyżyku — czego
		makieta nie ma. Panel ma `tabindex="-1"`, więc da się go zogniskować bez
		wchodzenia w kolejność tabulacji.
	*/
    modal.querySelector('.pp-modal__panel')?.focus();
}

export function closeModal(modal) {
    /*
		Blokadę przewijania zdejmujemy BEZWARUNKOWO i przed resztą — gdyby została po
		nieudanym otwarciu, strona zostałaby bez scrolla i nic by tego nie odkręciło.
		`overflow-y` na body ustawia components/pp-modal.scss.
	*/
    document.body.classList.remove(SCROLL_LOCK);

    if (modal) modal.hidden = true;
}

export function closeAllModals() {
    document.body.classList.remove(SCROLL_LOCK);
    document.querySelectorAll('[data-modal]').forEach((m) => {
        m.hidden = true;
    });
}

mount('[data-modal-open]', (trigger) => {
    trigger.addEventListener('click', (event) => {
        const name = trigger.dataset.modalOpen;
        const modal = document.querySelector(`[data-modal="${name}"]`);
        if (!modal) return; // brak modala = zostawiamy domyślne zachowanie odnośnika

        event.preventDefault();
        openModal(modal);
    });
});

mount('[data-modal]', (modal) => {
    // querySelectorAll, nie querySelector — komunikat po zgłoszeniu zamyka i krzyżyk,
    // i odnośnik „Powrót”, więc zamykaczy w jednym oknie bywa więcej niż jeden
    modal.querySelectorAll('[data-modal-close]').forEach((button) => {
        button.addEventListener('click', () => closeModal(modal));
    });
    // kliknięcie w przyciemnienie zamyka, kliknięcie w panel już nie
    modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal(modal);
    });
});

document.addEventListener('keydown', (event) => {
    if ('Escape' === event.key) closeAllModals();
});
